module.exports = __webpack_public_path__ + "static/img/img52.bea8c77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img52.png
// module id = 241b
// module chunks = 1